import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Stack,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import { boxStyle } from "../../styles/MUI-style-constants";
import { isMobile } from "react-device-detect";
import "../../styles/captionAI.scss";
import "../../styles/global.scss";

const SignUpForm = (props) => {
  const [name, setName] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [companySize, setCompanySize] = useState(null);
  const [companySizeReadable, setCompanySizeReadable] = useState(null);
  const [companySizeTokenAmount, setCompanySizeTokenAmount] = useState(null);
  const [formComplete, setFormComplete] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const companySizeOptions = [
    { key: "Just my Business", value: 0, tokenValue: 0 },
    { key: "1 - 2", value: 1, tokenValue: 1 },
    { key: "3 - 5", value: 2, tokenValue: 1 },
    { key: "6 - 10", value: 3, tokenValue: 2 },
    { key: "11 - 25", value: 4, tokenValue: 2 },
    { key: "26 - 50", value: 5, tokenValue: 2 },
    { key: "51+", value: 6, tokenValue: 2 },
  ];

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleCompanyNameChange = (event) => {
    setCompanyName(event.target.value);
  };

  const handleCompanySizeChange = (event) => {
    let readableSizeFromOptions = "Just my Business";
    let tokenAmount = 0;

    companySizeOptions.forEach((option) => {
      if (option.value === event.target.value) {
        readableSizeFromOptions = option.key;
        tokenAmount = option.tokenValue;
      }
    });
    setCompanySize(event.target.value);
    setCompanySizeReadable(readableSizeFromOptions);
    setCompanySizeTokenAmount(tokenAmount);
  };

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handleSubmit = () => {
    let fullname = name == undefined ? "" : name;
    fullname = fullname.trim();
    let indexOfLastSpace = fullname.lastIndexOf(" ");

    let firstName =
      indexOfLastSpace >= 0
        ? fullname.substring(0, indexOfLastSpace)
        : fullname;
    let lastName =
      indexOfLastSpace >= 0
        ? fullname.substring(indexOfLastSpace + 1, fullname.length)
        : "";

    let _hsq = (window._hsq = window._hsq || []);
    _hsq.push([
      "identify",
      {
        email: props.contact?.email,
        firstname: firstName,
        lastname: lastName,
        full_name: fullname,
        company: companyName,
        lead_source__updated_: "CaptionAI",
        client_count: companySizeReadable,
        phone: phoneNumber,
      },
    ]);
    _hsq.push(['trackPageView']);

    axios
      .post("/user/signup", {
        email: props.contact?.email,
        numCustomers: companySizeTokenAmount,
      })
      .then(() => {
        props.setShowSignUpForm(false);

        window.location.reload();
      })
      .catch((error) => {
        setEmailError(true);
        console.log(error);
      });
  };

  useEffect(() => {
    const validCheck =
      name && companyName && phoneNumber && companySize !== null;
    setFormComplete(validCheck);
  }, [name, companyName, companySize, phoneNumber]);

  return (
    <div>
      <div className="signup-background">&nbsp;</div>
      <Box sx={boxStyle}>
        <Typography variant="h4" margin={2}>
          User Details
        </Typography>
        {emailError ? (
          <Typography variant="h6" margin={1}>
            Something went wrong. Please try again.
          </Typography>
        ) : (
          <></>
        )}
        <Stack direction="column" margin={2}>
          <h5 className="signup-form-text">Name</h5>
          <TextField
            fullWidth
            variant="outlined"
            onChange={handleNameChange}
            value={name}
            error={name === ""}
          />
        </Stack>
        <Stack direction="column" margin={2}>
          <h5 className="signup-form-text">Phone Number</h5>
          <TextField
            fullWidth
            variant="outlined"
            onChange={handlePhoneNumberChange}
            value={phoneNumber}
            error={phoneNumber === ""}
          />
        </Stack>
        <Stack direction="column" margin={2}>
          <h5 className="signup-form-text">Company Name</h5>
          <TextField
            fullWidth
            variant="outlined"
            onChange={handleCompanyNameChange}
            value={companyName}
            error={companyName === ""}
          />
        </Stack>
        <Stack direction="column" margin={2}>
          <h5 className="signup-form-text">
            How many social media clients do you actively manage?
          </h5>
          <Select
            value={companySize}
            label="Tone"
            onChange={handleCompanySizeChange}
            native={isMobile}
          >
            {companySizeOptions.map((option) =>
              isMobile ? (
                <option key={option.key} value={option.value}>
                  {option.key}
                </option>
              ) : (
                <MenuItem key={option.key} value={option.value}>
                  {option.key}
                </MenuItem>
              )
            )}
          </Select>
        </Stack>
        <Stack direction="row" justifyContent="center" margin={2}>
          <Button
            variant="contained"
            color="cc"
            fullWidth
            onClick={handleSubmit}
            disabled={!formComplete}
          >
            Submit
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export default SignUpForm;
